import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@ingka/button';

const Telephone = ({
    phoneNumber,
    contactLabel,
    storeOpened,
    activateAnalytics,
    colorButton,
    ariaLabel,
    buttonStyles,
}) => {
    const [phoneState, setPhoneState] = useState(true);

    // State has an initial value according to the device size.
    useEffect(() => {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth < 600) {
            setPhoneState(phoneNumber);
        } else {
            setPhoneState(contactLabel);
        }
    }, [contactLabel, phoneNumber]);

    const activateContactAndAnalystics = () => {
        activateAnalytics('Button');
        setPhoneState(phoneNumber);
        return window.location.assign(`tel:${phoneNumber}`);
    };
    return (
        <Button
            data-cy="contactcard-button"
            type={colorButton}
            aria-label={ariaLabel}
            className={buttonStyles}
            onClick={() => activateContactAndAnalystics()}
            disabled={!storeOpened}
        >
            {phoneState}
        </Button>
    );
};

Telephone.propTypes = {
    activateAnalytics: PropTypes.func,
    ariaLabel: PropTypes.string,
    contactLabel: PropTypes.string,
    colorButton: PropTypes.string,
    buttonStyles: PropTypes.string,
    phoneNumber: PropTypes.string,
    storeOpened: PropTypes.bool,
};
export default Telephone;
